import { getConfig } from "./getConfig";

export const getEnvironmentName = (): string | null => {
    const config = getConfig();

    return config.EnvironmentName;
};
